import { IToast } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';

export enum SnackbarMessages {
  USER_ADDED_SUCCESSFULLY = 'User added successfully',
  USER_DELETED_SUCCESSFULLY = 'User deleted successfully'
}

export function showSnackbar(
  type: SnackbarMessages,
  error: boolean,
  canUndo: boolean
): IShowSnackbarAction {
  return {
    type: actionTypes.SHOW_SNACKBAR,
    payload: { type, error, canUndo }
  };
}

export function hideSnackbar(id: number): IHideSnackbarAction {
  return {
    type: actionTypes.HIDE_SNACKBAR,
    payload: {
      id
    }
  };
}

export interface IShowSnackbarAction {
  type: actionTypes.SHOW_SNACKBAR;
  payload: Pick<IToast, 'type' | 'error' | 'canUndo'>;
}

export interface IHideSnackbarAction {
  type: actionTypes.HIDE_SNACKBAR;
  payload: {
    id: number;
  };
}

export type SnackbarAction = IShowSnackbarAction | IHideSnackbarAction;
